import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';
import RouteComponent from '../../components/RouteComponent';

export default class Page extends RouteComponent {
	render() {
		return (
			<DocumentTitle title="Praktické dovednosti">
				<TabbablePage
					module="praxe"
					List={List}
					Form={Form}
					newTitle="Nová"
					listTitle="Seznam praktických dovedností"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Praxe/Page.js